import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/lib/queryClient";
import { useCurrentOrganization } from "./use-current-organization";

/**
 * Hook to get the current organization's currency
 * Returns the currency code (defaults to 'EUR' if not set)
 */
export function useOrganizationCurrency() {
  const { organizationId } = useCurrentOrganization();

  const { data: orgMeResponse } = useQuery({
    queryKey: ["/api/orgs/me", organizationId],
    queryFn: async () => {
      const url = organizationId 
        ? `/api/orgs/me?organizationId=${encodeURIComponent(organizationId)}`
        : '/api/orgs/me';
      const res = await apiRequest(url);
      return await res.json();
    },
    enabled: !!organizationId,
    staleTime: 60_000, // Cache for 1 minute
    retry: false,
  });

  const orgInfo = (orgMeResponse as any)?.data || null;
  const currency = orgInfo?.currency || 'EUR';

  return currency;
}

